import { HStack, Link, Text } from '@chakra-ui/react'
import { LEGAL_DOCS } from '../../config/legal'

interface LegalFooterLinksProps {
  /** Text color — pass a light token when placed on a dark background. */
  color?: string
  justify?: 'center' | 'flex-start' | 'flex-end'
}

/**
 * Compact row of links to the public legal documents (CGU, CGV, mentions
 * légales, confidentialité). Opens each in a new tab so it never disrupts an
 * in-progress form. Drop into auth screens, sidebars or app footers.
 */
export default function LegalFooterLinks({ color = 'gray.500', justify = 'center' }: LegalFooterLinksProps) {
  return (
    <HStack spacing={2} justify={justify} flexWrap="wrap" fontSize="2xs">
      {LEGAL_DOCS.map((d, i) => (
        <HStack key={d.slug} spacing={2}>
          {i > 0 && <Text color={color} opacity={0.5}>·</Text>}
          <Link href={`/legal/${d.slug}`} target="_blank" color={color} _hover={{ textDecoration: 'underline' }}>
            {d.label}
          </Link>
        </HStack>
      ))}
    </HStack>
  )
}
